import * as eventBus from './eventBus'

export default {
    eventBus
}
